import { createSlice } from "@reduxjs/toolkit";
import { initialMyRenewalsState } from "./myRenewals.types";
import { fetchGeneratedPremiumReportList, fetchMyRenewalsList } from "./myRenewalsThunk";
import { LoadState } from "../../constants/enums";

 const myRenewalsSlice = createSlice({
  name: "myRenewals",
  initialState: initialMyRenewalsState,
  reducers: {
    clearMyRenewalsState: (state) => {
      return initialMyRenewalsState;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchMyRenewalsList.pending, (state) => {
      state.loading = LoadState.InProgress;
      state.list = [];
    });
    builder.addCase(fetchMyRenewalsList.fulfilled, (state, action) => {
      state.loading = LoadState.Loaded;
      state.list = action.payload.data;
    });
    builder.addCase(fetchMyRenewalsList.rejected, (state) => {
      state.loading = LoadState.Failed;
      state.list = [];
    });
     builder.addCase(fetchGeneratedPremiumReportList.pending, (state) => {
      state.generatedPremiumReportLoading = LoadState.InProgress;
      state.generatedPremiumReportList = [];
    });
    builder.addCase(fetchGeneratedPremiumReportList.fulfilled, (state, action) => {
      state.generatedPremiumReportLoading = LoadState.Loaded;
      state.generatedPremiumReportList = action.payload.data;
    });
    builder.addCase(fetchGeneratedPremiumReportList.rejected, (state) => {
      state.generatedPremiumReportLoading = LoadState.Failed;
      state.generatedPremiumReportList = [];
    });
  },
});


export const { clearMyRenewalsState } = myRenewalsSlice.actions;
export const myRenewalsReducer = myRenewalsSlice.reducer;